import { useToast } from "vue-toastification";

export default function (error) {
  const toast = useToast();
  var pathname = document.location.pathname
  var error_message = ''
  if (error.response != null && error.response.data != null && error.response.data['code_message'] != null) {
    error_message = error.response.data['code_message']
  } else if (error.response != null && error.response.data != null && error.response.data.error != null && error.response.data.error.message != null) {
    error_message = error.response.data.error.message
  } else {
    error_message = error.message
  }

  console.log(error_message)
  var unauthorized = true

  unauthorized = (error.response != null && (error.response.status == 401 || error.response.data['code'] == 401))

  if ((pathname != 'auth/login' && pathname != 'auth/register') && unauthorized) {

    localStorage.removeItem('user')
    localStorage['flash'] = 'Please re-login to continue'
    document.location = ''
    // toast.error(error.response.data['code_message'], {
    //   onDismiss: document.location = '',
    //   duration: 30000
    // })
  } else {

    toast.error(error_message)
  }

}